import React, { useEffect, useState } from "react";
import Select, { MultiValue, ActionMeta } from 'react-select';

export type MultiOption = {
  value: string;
  label: string;
};

export interface MultiSelectProps {
  options: MultiOption[];
  value?: MultiOption[]; // Array of selected options
  className?: string;
  onChange?: (selected: MultiOption[]) => void;
  isLoading?: boolean;
}

const CommonMultiSelect: React.FC<MultiSelectProps> = ({
  options,
  value = [],
  className,
  onChange,
  isLoading = false,
}) => {
  const [selectedValues, setSelectedValues] = useState<MultiOption[]>(value);

 

  const handleChange = (
    selected: MultiValue<MultiOption>,
    _actionMeta: ActionMeta<MultiOption>
  ) => {
    const selectedArray = selected as MultiOption[];
    setSelectedValues(selectedArray);
    if (onChange) {
      onChange(selectedArray);
    }
  };

  useEffect(() => {
    setSelectedValues(value);
  }, [value]);

  return (
    <Select
      options={options}
      onChange={handleChange}
      value={selectedValues}
      isSearchable={true} // FIX: Changed to true to enable searching
      placeholder={!isLoading ? "Loading options..." : "Select options"}
      className={className}
      isMulti
      closeMenuOnSelect={false}
      tabSelectsValue={false}
      backspaceRemovesValue={false}
      hideSelectedOptions={false}
      blurInputOnSelect={false}
    //isLoading={isLoading}
    />
  );
};

export default CommonMultiSelect;
